import { request } from '@umijs/max';

export interface ErrorNoticeItem {
  id: number;
  userUuid: string;
  appUuid: string;
  appName: string;
  operatorName: string;
  url: string;
  method: string;
  params: string;
  errorMsg: string;
  exceptionType: string;
  stackTrace: string;
  statusCode: number;
  logCategory: number;
  clientIp: string;
  userAgent: string;
  requestId: string;
  createdAt: string;
  isRead: number;
  readAt: string;
}

export interface ErrorNoticeListRes {
  unreadCount: number;
  list: ErrorNoticeItem[];
}

export async function fetchErrorNoticeList(size = 20): Promise<ErrorNoticeListRes> {
  return request('/api/sys-error-notice/list', {
    method: 'POST',
    data: { size },
  });
}

export async function markErrorNoticeRead(ids: number[]): Promise<{ code?: number; msg?: string }> {
  return request('/api/sys-error-notice/read', {
    method: 'POST',
    data: { ids },
  });
}
